import { SINK_TYPE } from '@shared-lib/sink-types';

// Unit conversion constants
export const METERS_TO_INCHES = 39.3701;
export const INCHES_TO_METERS = 0.0254;

// Fixture SIZES do not live here. Defaults and shrink floors are the
// shared-lib pipeline's `FIXTURE_PHYSICAL` / `MIN_PHYSICAL_DIMENSIONS`
// (shared-lib/bathroom-analyzer/pipeline/types.js) with clearances from
// shared-lib/collision/clearanceConfig.js — the single source of truth for
// both the generator and the web-app. The parallel table that used to sit
// here fed only the V1 analyzer, removed 2026-08-21.

// Object types that count as bathroom fixtures for drawing order / category
// grouping (web-app-only concern; there is no shared-lib equivalent).
export const BATHROOM_FIXTURE_TYPES = [
  'toilet',
  'double-sink',
  'bathtub',
  'tub-shower',
  'shower',
  'vanity',
  SINK_TYPE,
  'bathroom-sink-faucet',
  'bathroom-tub-faucet',
  'shower-controls',
  'shower-stem',
];

export const isBathroomFixtureType = (type) => {
  return BATHROOM_FIXTURE_TYPES.includes(type?.toLowerCase());
};
